import { render } from "./project-place.vue?vue&type=template&id=dee42e70&scoped=true&ts=true"
import script from "./project-place.vue?vue&type=script&lang=ts"
export * from "./project-place.vue?vue&type=script&lang=ts"

import "./project-place.vue?vue&type=style&index=0&id=dee42e70&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee42e70"]])

export default __exports__